import React, { Component } from 'react';
import Radium from 'radium';

import ImageJumbotron from '../../components/ImageJumbotron/ImageJumbotron';
import Explainer from '../../components/Explainer/Explainer';
import Navbar from '../../components/Navbar/Navbar';
import MainText from '../../components/MainText/MainText';
// import MediaFooter from '../../components/MediaFooter/MediaFooter';
import Footer from '../../components/Footer/Footer';
import MailCapture from '../../components/Mail/Mail';

import styles from './HomeStyle';

class Home extends Component {
    render() {
        return (
            <div>
                <div className="container-fluid" style={styles.container}>
                    <Navbar />
                    <ImageJumbotron />
                </div>
                <div className="container">
                    <MainText />
                    <Explainer />
                    <div className="col-xs-12 col-md-10" style={{marginBottom: 30}}>
                        <MailCapture />
                    </div>
                </div>
                {/*<MediaFooter />*/}
                <Footer />
            </div>
        );
    }
}

export default Radium(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js